import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { RootState } from '../rootReducer';
import { putFreeTrial } from '../../actions/integration/integration';
import { FetchError } from '../../models/errors';

export interface IBeginFreeTrialSlice {
    isStartingTrial: boolean;
    error?: Error;
}

export const initialState: IBeginFreeTrialSlice = {
    isStartingTrial: false,
};

const name = 'freeTrial';

const beginFreeTrialSlice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(beginFreeTrialAction.pending, (state) => {
                state.isStartingTrial = true;
            })
            .addCase(beginFreeTrialAction.fulfilled, (state) => {
                state.isStartingTrial = false;
                state.error = undefined;
            })
            .addCase(beginFreeTrialAction.rejected, (state, { payload }) => {
                state.isStartingTrial = false;
                state.error = payload;
            });
    },
});

export const beginFreeTrialAction = createAsyncThunk<void, void, { state: RootState; rejectValue: FetchError }>(
    `${name}/putFreeTrial`,
    async (_, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            return await putFreeTrial(state.user.user, state.installation.installation);
        } catch (error) {
            if (error instanceof FetchError) {
                // api response errors i.e. 400 and 404
                return rejectWithValue({
                    name: error.name,
                    message: error.message,
                    code: error.code,
                    body: error.body,
                });
            }
            return rejectWithValue(error);
        }
    }
);

export const beginFreeTrialSelectors = {
    isStartingTrial: (state: RootState) => state.freeTrial.isStartingTrial,
    error: (state: RootState) => state.freeTrial.error,
};

export default beginFreeTrialSlice.reducer;
